import React from "react";

import PropTypes from "prop-types";

import RbField from "../RbField";
import RbTextControl from "../RbTextControl";

function RbTextField(props) {
  const { fieldName, required, ...other } = props;

  const validate = React.useCallback(
    (value) => {
      if (!value && required) {
        return "Required field";
      }

      return undefined;
    },
    [required]
  );

  return (
    <RbField
      Component={RbTextControl}
      defaultEmptyValue=""
      fieldName={fieldName}
      required={required}
      validate={validate}
      {...other}
    />
  );
}

RbTextField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

RbTextField.defaultProps = {
  required: undefined,
};

export default React.memo(RbTextField);
